{
	"showButtonTitle": "Mostra",
	"hideButtonTitle": "Nascondi"
}
